import React from 'react';
import { Components } from "../base";
import { useTableClient } from "./use-table-client.hook";
import { isMobile, isTablet } from '@isyc-react/core/device';
export const TableClient = props => {
  const {
    options = {},
    components = Components,
    className,
    summary = '',
    hasMobileView = false
  } = props;
  const {
    Pagination = Components.Pagination,
    ListMobile = Components.ListMobile
    // TableCheckbox = Components.TableCheckbox,
  } = components;
  const instance = useTableClient(props);

  // console.log('instance', instance)

  return /*#__PURE__*/React.createElement(React.Fragment, null, hasMobileView ? (!isMobile || isTablet) && /*#__PURE__*/React.createElement(FilterTableComponent, {
    components: components,
    instance: instance,
    className: className,
    summary: summary
  }) : /*#__PURE__*/React.createElement(FilterTableComponent, {
    components: components,
    instance: instance,
    className: className,
    summary: summary
  }), hasMobileView && isMobile && !isTablet && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListMobile, {
    instance: instance
  })), /*#__PURE__*/React.createElement(Pagination, {
    instance: instance,
    pagination: options.pagination,
    hasMobileView: hasMobileView
  }));
};
const FilterTableComponent = props => {
  const {
    components,
    instance,
    className,
    summary
  } = props;
  const {
    Filter = Components.Filter,
    Table = Components.Table,
    TableBody = Components.TableBody,
    TableHead = Components.TableHead
  } = components;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Filter, {
    instance: instance
  }), /*#__PURE__*/React.createElement(Table, {
    instance: instance,
    className: className,
    summary: summary
  }, /*#__PURE__*/React.createElement(TableHead, {
    instance: instance
  }), /*#__PURE__*/React.createElement(TableBody, {
    instance: instance
  })));
};